"use client";
/**
 * Drepturile omului pe module, disponibile oricărei componente client — SURSA UNICĂ a
 * afișării butoanelor de scriere.
 *
 * Până aici fiecare pagină calcula `canWrite` pe server și îl trimitea mai jos; unde pagina
 * uita, componenta cădea pe `canWrite = true` și rolul de doar citire vedea „Comandă nouă",
 * „Furnizor nou", „Aprobă" — butoane pe care serverul le refuza apoi la apăsare. Regula de
 * aici e EXACT cea a gărzii din registru (`permAllows` din roles.ts), deci ce se ascunde e
 * ce s-ar refuza. Garda din server rămâne cea care decide; asta e doar afișarea.
 *
 * Fără sesiune (vitrina, portalul) contextul e gol → nimic de scriere nu se arată.
 */
import { createContext, useContext } from "react";
import { permAllows, type PermissionSet } from "@/lib/roles";
import type { ActionModule } from "@/lib/actions/types";

const RightsContext = createContext<PermissionSet | null>(null);

export function RightsProvider({ perms, children }: { perms: PermissionSet | null; children: React.ReactNode }) {
  return <RightsContext.Provider value={perms}>{children}</RightsContext.Provider>;
}

/** Poate omul modifica în modulul dat? (aceeași întrebare pe care o pune garda la o mutație) */
export function useCanWrite(modul: ActionModule): boolean {
  return permAllows(useContext(RightsContext) ?? undefined, modul, true);
}

/** Afișează conținutul doar dacă omul are drept de scriere în modul. */
export function CuScriere({ modul, children }: { modul: ActionModule; children: React.ReactNode }) {
  return useCanWrite(modul) ? <>{children}</> : null;
}
